import React from 'react';

import styles from '@app/components/UI/Modal/Modal.module.scss';

interface CustomModalProps {
	modalVisible: boolean;
	setModalVisible: (e: boolean) => void;
}

const CustomModal: React.FC<CustomModalProps> = ({ modalVisible, setModalVisible, children }) => {
	return modalVisible ? (
		<div
			className={styles.container}
			onClick={() => setModalVisible(false)}
		>
			<div
				className={styles.content}
				onClick={(e) => e.stopPropagation()}
			>
				{children}
			</div>
		</div>
	) : null;
};

export default CustomModal;
